import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FilePlus, Printer } from "lucide-react";
import { Prescription } from "@/types";

interface PrescriptionCardProps {
  prescription: Prescription;
  getDoctorName: (doctorId: string) => string;
  onViewPrescription: (prescription: Prescription) => void;
  onPrintPrescription?: (prescription: Prescription) => void;
  showPrintButton?: boolean;
}

export function PrescriptionCard({ 
  prescription, 
  getDoctorName, 
  onViewPrescription,
  onPrintPrescription,
  showPrintButton = false
}: PrescriptionCardProps) {
  return (
    <div className="border rounded-md p-3 hover:bg-muted/30 transition-colors">
      <div className="flex justify-between items-start">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <FilePlus className="h-4 w-4 text-muted-foreground" />
            <p className="text-sm font-medium">
              {new Date(prescription.createdAt).toLocaleDateString()}
            </p>
          </div>
          <p className="text-xs text-muted-foreground">
            By: {getDoctorName(prescription.doctorId)}
          </p>
          <div className="mt-1">
            <Badge variant={prescription.status === 'issued' ? 'default' : 'outline'}>
              {prescription.status === 'issued' ? 'Issued' : 'Draft'}
            </Badge>
          </div>
          <p className="text-xs mt-2">
            Medications: {prescription.medications.length}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => onViewPrescription(prescription)}
          >
            {prescription.status === 'draft' ? 'Edit' : 'View'}
          </Button>
          {showPrintButton && onPrintPrescription && prescription.status === 'issued' && (
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => onPrintPrescription(prescription)}
            >
              <Printer className="h-4 w-4 mr-1" />
              Print
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
